import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const ReferralRedirect = () => {
  const { codice } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (codice) {
      localStorage.setItem("yollo_referral_code", codice);
    }
    navigate("/register", { replace: true });
  }, [codice, navigate]);

  return null;
};

export default ReferralRedirect;
